let twitterScriptPromise = null;
let instaScriptPromise = null;

function loadScriptOnce(src, promiseRef, setPromiseRef) {
  if (typeof window === "undefined") return Promise.resolve();
  if (promiseRef) return promiseRef;

 
  const promise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = resolve;
    document.body.appendChild(script);
  });

  setPromiseRef(promise);
  return promise;
}

export function loadTwitterWidgets() {
  return loadScriptOnce(
    "https://platform.twitter.com/widgets.js",
    twitterScriptPromise,
    (p) => {
      twitterScriptPromise = p;
    }
  );
}

export function loadInstagramEmbed() {
  return loadScriptOnce(
    "https://www.instagram.com/embed.js",
    instaScriptPromise,
    (p) => {
      instaScriptPromise = p;
    }
  );
}

export function processTwitterEmbeds(container) {
  return loadTwitterWidgets().then(() => {
    window?.twttr?.widgets?.load(container);
  });
}

export function processInstagramEmbeds() {
  return loadInstagramEmbed().then(() => {
    window?.instgrm?.Embeds?.process();
  });
}
